// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { Popover, Button, ButtonProps, Paragraph, PopoverProps } from '@plesk/ui-library';
import { Locale } from 'jsw';
import { useState, ReactNode, cloneElement } from 'react';

const ButtonsTranslate = Locale.getTranslate('components.buttons');

type ButtonWithConfirmationProps = ButtonProps &{
    children?: ReactNode;
    confirmationText: ReactNode;
    onClick: () => void;
    isCritical?: boolean;
    isProcessing?: boolean;
    target?: PopoverProps['target'];
};

const ButtonWithConfirmation = ({
    children,
    confirmationText,
    onClick,
    isCritical = false,
    isProcessing = false,
    target,
    ...props
}: ButtonWithConfirmationProps) => {
    const [visible, setVisible] = useState(false);

    const button = (
        <Button
            onClick={() => setVisible(true)}
            state={isProcessing ? 'loading' : undefined}
            {...props}
        >
            {isProcessing ? <ButtonsTranslate content="wait" /> : children}
        </Button>
    );

    return (
        <Popover
            target={target ? cloneElement(target as React.ReactElement, { onClick: () => setVisible(true) }) : button}
            placement="top"
            visible={visible}
            onClose={() => setVisible(false)}
        >
            <Paragraph>{confirmationText}</Paragraph>
            <Button
                id="buttonYes"
                intent={isCritical ? 'danger' : 'primary'}
                onClick={() => {
                    setVisible(false);
                    onClick();
                }}
            >
                <ButtonsTranslate content="yes" />
            </Button>
            {'  '}
            <Button id="buttonCancel" onClick={() => setVisible(false)} ghost>
                <ButtonsTranslate content="cancel" />
            </Button>
        </Popover>
    );
};

export default ButtonWithConfirmation;
